import React from 'react';

import {
  Text,
} from 'web-styled';

import {
  Spinner,
  NotFound,
} from 'web-components';

import Video from './Video';
import * as S from './styled';

type Props = {
  videos: any[],
  isError: boolean,
  isEmpty: boolean,
  isLoading: boolean,
  assignedId: string,
  assignedText: string,
  assignButton: string,
  onAssign: { (): void },
};

const Videos = ({
  videos,
  isEmpty,
  isError,
  isLoading,
  assignedId,
  assignedText,
  assignButton,
  onAssign,
}: Props) => (
  <S.Videos>
    {(!isLoading && isError) && (
      <NotFound
        messages={[
          'Sorry!',
          'No videos were found.',
          'Try another search query.',
        ]}
      />
    )}

    {(!isLoading && isEmpty) && (
      <S.Starting>
        <S.StartIcon />
        <Text color="#9ea0a1">
          Start searching a video
          <br />
          in a Search Bar above
        </Text>
      </S.Starting>
    )}

    {isLoading && (
      <Spinner message="Loading videos..." />
    )}

    {!!videos && videos.map(video => (
      <Video
        key={video.id}
        video={video}
        assigned={video.id === assignedId}
        assignedId={assignedId}
        assignedText={assignedText}
        assignButton={assignButton}
        onAssign={onAssign}
      />
    ))}
  </S.Videos>
);

export default Videos;
